import { useEffect } from "react";
import { GD } from "src/GD";
import { StartScreenView } from "../StartScreenView";
import { AuthCard, AuthStatus } from "./AuthLayout";

export const KycReturnPage = () => {
	useEffect(() => {
		GD.S_AUTH_LOG_OUT.invoke();
	}, []);

	return (
		<StartScreenView busy>
			<AuthCard
				icon="success"
				eyebrow="Identity verification"
				title="Verification complete"
				subtitle="Returning you to Cardpartner securely."
			>
				<AuthStatus>Opening the sign-in page…</AuthStatus>
			</AuthCard>
		</StartScreenView>
	);
};
